import React, { useState, Fragment } from "react"
import { useSelector } from "react-redux"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { FoodModal } from "components"
import { productUnitsSymbol } from "constant"
import FoodOrderItemCardHeader from "./FoodOrderItemCardHeader"
import { isNewItemInPreviousOrder, thousandSeparator } from "utils"
import FoodOrderSpecificationItemCard from "./FoodOrderSpecificationItemCard"
import classes from "./index.module.scss"

const FoodOrderItemCard = props => {
  const { orderItem } = props

  const [t, i18n] = useTranslation()

  const food =
    useSelector(state => state.foods[orderItem.foodId])

  const [openModal, setOpenModal] = useState(false)

  const initialValues = {
    orderItemId: orderItem.orderItemId,
    optionId: orderItem.optionId,
    quantity: String(orderItem.quantity),
    reduction: String(orderItem.systemDiscount),
    specificationItems: orderItem.specificationItems,
    discount:
      String(
        Math.round(
          (orderItem.systemDiscount / orderItem.salePrice) * 100
        )
      )
    ,
    salePrice:
      String(
        Math.round(
          orderItem.salePrice - orderItem.systemDiscount
        )
      )
  }

  const isNew =
    isNewItemInPreviousOrder(orderItem)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  const portionItems = portion => orderItem.specificationItems.filter(item =>
    portion === "whole" ? !item.portion || item.portion === "whole" : item.portion === portion
  )
  const renderItems = items => items.map(specificationItem =>
    <FoodOrderSpecificationItemCard
      key={`${specificationItem.builderStepKey || "whole"}-${specificationItem._id}`}
      orderItemQuantity={orderItem.quantity}
      specificationItem={specificationItem}
    />
  )
  const renderPortion = (faTitle, enTitle, portion) => {
    const items = portionItems(portion)
    return items.length > 0 && <section className={classes["portion"]}>
      <div className={classes["portion-title"]}>{i18n.language === "fa" ? faTitle : enTitle}</div>
      {renderItems(items)}
    </section>
  }

  return (
    <Fragment>
      <div className={classes["container"]}>
        <FoodOrderItemCardHeader
          orderItem={orderItem}
        />
        <div
          className={classes["content"]}
          onClick={() => setOpenModal(true)}
        >
          <div className={classes["wrapper"]}>
            <div className={classes["names"]}>
              <div
                className={clsx(
                  classes["name"],
                  isNew && classes["new"]
                )}
              >
                {orderItem.foodName}
              </div>
              {
                !orderItem.isSimple &&
                <div
                  className={clsx(
                    classes["option"],
                    isNew && classes["new"]
                  )}
                >
                  ({orderItem.optionName})
                </div>
              }
            </div>
            <div
              className={clsx(
                classes["quantity"],
                 isLtr && classes["quantity-ltr"],
                isNew && classes["new"]
              )}
            >
              <MdClose />
              {orderItem.quantity}{productUnitsSymbol[orderItem.unit]}
            </div>
          </div>
          <div className={clsx(classes["price"], isLtr && classes["price-ltr"])}>
            {orderItem.systemDiscount !== 0
              ?
              thousandSeparator(
                (orderItem.salePrice - orderItem.systemDiscount) *
                orderItem.quantity
              )
              :
              thousandSeparator(
                orderItem.salePrice * orderItem.quantity
              )
            }
          </div>
          {
            orderItem.systemDiscount > 0 &&
            <div className={clsx(classes["discount"], isLtr && classes["discount-ltr"])}>
              {t("تخفیف")}:{" "}
              {thousandSeparator(
                -orderItem.systemDiscount * orderItem.quantity
              )}
            </div>
          }
          <div
            className={clsx(
              classes["left"],
              orderItem.specificationItems.length > 0 && classes["margin"]
            )}
          >
            {renderItems(portionItems("whole"))}
            {renderPortion("نیمه اول", "First half", "firstHalf")}
            {renderPortion("نیمه دوم", "Second half", "secondHalf")}
          </div>
        </div>
      </div>
      {
        !!food &&
        <FoodModal
          food={food}
          openModal={openModal}
          setOpenModal={setOpenModal}
          initialValues={initialValues}
        />
      }
    </Fragment>
  )
}

export default React.memo(FoodOrderItemCard)
